import { render, staticRenderFns } from "./AuditMessages.vue?vue&type=template&id=31c3a000"
import script from "./AuditMessages.vue?vue&type=script&lang=ts"
export * from "./AuditMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports